import React from 'react';
import { useTheme } from 'styled-components';

export const SearchIcon = () => {
  const theme = useTheme();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <path d="M0 0H22V22H0z" transform="translate(-530.000000, -217.000000) translate(530.000000, 217.000000)" />
            <path fill={theme.colors.accentGray05} d="M20.424 19.451l-5.677-5.677c2.479-2.97 2.327-7.395-.462-10.184-1.477-1.477-3.412-2.215-5.348-2.215-1.935 0-3.87.738-5.347 2.215-2.953 2.953-2.953 7.742 0 10.695C5.067 15.762 7.002 16.5 8.937 16.5c1.72 0 3.44-.587 4.837-1.753l5.677 5.677c.135.134.31.201.486.201s.352-.067.487-.201c.268-.269.268-.704 0-.973zM4.562 13.313C3.394 12.144 2.75 10.59 2.75 8.937c0-1.652.644-3.206 1.812-4.375C5.731 3.394 7.285 2.75 8.937 2.75c1.653 0 3.207.644 4.376 1.812 1.168 1.169 1.812 2.723 1.812 4.375 0 1.653-.644 3.207-1.812 4.376-1.169 1.168-2.723 1.812-4.376 1.812-1.652 0-3.206-.644-4.375-1.812z" transform="translate(-530.000000, -217.000000) translate(530.000000, 217.000000)" />
          </g>
        </g>
      </g>
    </svg>
  );
};
